import useAPICall from "../../../../hooks/useAPICall";
import en from "../../../../Lang/en.json";
import { GET_BCC } from "../../../../utilities/apis";

const useGetBCC = () => {
  const [data, error, isLoading, callGetData, setSuccessData, setError] =
    useAPICall(undefined, "");

  const defaultFallback = () => {
    setError(en.something_went_wrong);
    setSuccessData(undefined);
  };

  const statusObj = [
    {
      status_code: "200",
      status_txt: "OK",
      callBack: (res) => {
        const data = res.data;
        if (data && typeof data === "object") {
          setSuccessData(data);
        } else {
          defaultFallback();
        }
      },
    },
    {
      status_txt: "Bad Request",
      status_code: "400",
      callBack: defaultFallback,
    },
    {
      status_txt: "Internal Server Error",
      status_code: 500,
      callBack: defaultFallback,
    },
  ];

  const getBCC = (item) => {
    const url = `${process.env.REACT_APP_API_URL}${GET_BCC}${item}/`;
    callGetData({
      url,
      method: "GET",
      statusObj,
      defaultFallback,
    });
  };
  return [data, error, isLoading, getBCC, setSuccessData, setError];
};

export default useGetBCC;
